import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { MainStore } from "./store/MainStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={MainStore}>
    <App />
  </Provider>
  // </React.StrictMode>
);
